import { ReactNode } from 'react'

interface SectionHeaderProps {
  title: string
  subtitle: string
  className?: string
  children?: ReactNode
}

export function SectionHeader({
  title,
  subtitle,
  className = '',
  children,
}: SectionHeaderProps) {
  return (
    <section className={`px-md ${className}`}>
      <div
        data-id="HeaderKey"
        className="rounded-lg py-16 text-center bg-primary-5 md:py-40"
      >
        <h1 className="font-sans text-sm font-bold tracking-widest text-primary md:text-xl">
          {title}
        </h1>
        <h1 className="mt-4 text-xl font-semibold md:mt-6 md:text-3xl">
          {subtitle}
        </h1>
      </div>
      {children && (
        <div className="px-lg">
          <div className="mx-auto mt-8 grid max-w-2xl gap-y-fz-0.75 text-sm leading-loose md:mt-16 md:text-base">
            {children}
          </div>
        </div>
      )}
    </section>
  )
}
